export function setFontt(doc, isHeader, bold, italic) {
  if (isHeader) {
    doc.setFont("calibri", "bold");
    doc.setFontSize(12);
    doc.setTextColor(53, 71, 123);
  }
  else if (bold && italic) {
    doc.setFont("calibri", "bold_italic");
    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0); // Black
  }
  else if (bold && !italic) {
    doc.setFont("calibri", "bold");
    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0); // Black
  }
  else if (!bold && italic) {
    doc.setFont("calibri", "italic");
    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0); // Black
  } else {
    doc.setFont("calibri", "normal");
    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0); // Black
  }
}
